import {Component, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Layout} from '@selpia/shared/models';
import {FeatureTileGridComponent} from '../feature-tile-grid/feature-tile-grid.component';
import {FeatureTileListComponent} from '../feature-tile-list/feature-tile-list.component';

@Component({
  selector: 'lib-feature-tile-preview',
  imports: [CommonModule, FeatureTileGridComponent, FeatureTileListComponent],
  templateUrl: './feature-tile-preview.component.html',
  styleUrl: './feature-tile-preview.component.scss',
})
export class FeatureTilePreviewComponent {
  layout = input.required<Layout>();
  readonly reportPath = input.required<string>();

  protected readonly Layout = Layout;
}
